import React from 'react';
import styled from 'styled-components';

import { Radio, Text, Markdown } from '@devfolioco/genesis';

import * as S from '../style';

const alphabets = 'ABCDE';

const StyledMarkdown = styled(Markdown)`
  p:first-child {
    margin-top: 16px;
  }
`;

const Option = React.memo(({ index, name, text, checked, onClick }) => (
  <S.OptionContainer onClick={() => onClick(name)} type="button">
    <Radio
      name={name}
      checked={checked}
      value={text}
      appearance="large"
      label={alphabets[index]}
      style={{ margin: 0, width: 92, pointerEvents: 'none' }}
      onChange={() => onClick(name)}
    />
    <Text upgrade size={18} weight={checked ? 'bold' : 'regular'} style={{ marginLeft: 24 }}>
      <StyledMarkdown>{text}</StyledMarkdown>
    </Text>
  </S.OptionContainer>
));

export default Option;
